<template>
  <div class="flex h-screen bg-gray-100">
    <aside class="nav-container w-64 bg-blue-900 text-white flex flex-col p-4 space-y-8">
      <div class="flex items-center">
        <img src="/image/im8.png" alt="Logo AdminGate" class="h-16 w-16 mr-2">
        <h1 class="text-1xl font-bold font-serif">AdminGate</h1>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im34.png" class="h-6 w-6 mr-2">
        <router-link to="/dash" class="hover:bg-blue-900 p-2 rounded transition">Dashboard</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im36.png" class="h-6 w-6 mr-2">
        <router-link to="/student" class="hover:bg-blue-900 p-2 rounded transition">Étudiants</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/icour.png" class="h-6 w-6 mr-2">
        <router-link to="/study" class="hover:bg-blue-900 p-2 rounded transition">Cours</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im35.png" class="h-6 w-6 mr-2">
        <router-link to="/event" class="hover:bg-blue-900 p-2 rounded transition">Calendrier</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im33.png" class="h-6 w-6 mr-2">
        <router-link to="/note" class="hover:bg-blue-900 p-2 rounded transition">Évaluations</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im38.png" class="h-6 w-6 mr-2">
        <router-link to="/" class="hover:bg-blue-900 p-2 rounded transition">Logout</router-link>
      </div>
    </aside>

    <main class="flex-1 p-6 overflow-y-auto bg-white">
      <div class="max-w-4xl mx-auto space-y-8 font-serif">
        <div>
          <div class="flex justify-center font-serif">
            <img src="/image/im43.png" class="h-8 w-8 mr-2" />
            <h2 class="text-3xl text-blue-900 mb-4">Gestion des Événements</h2>
          </div>

          <h2 class="text-1xl font-bold mb-4">Ajouter/Modifier un événement</h2>
          <form @submit.prevent="isEditing ? modifierEvent() : ajouterEvent()" class="grid grid-cols-2 gap-4 p-6 rounded shadow">
            <input v-model="form.titre" placeholder="Titre" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            
            <select v-model="form.type" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none">
              <option value="">Sélectionnez un type</option>
              <option value="cours">Cours</option>
              <option value="examen">Examen</option>
            </select>

            <input v-model="form.start" type="datetime-local" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none font-serif" />
            
            <input v-model="form.end" type="datetime-local" class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none font-serif" />
            
            <select v-model="form.niveau" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none">
              <option value="">Sélectionnez un niveau</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </select>

            <div class="col-span-2 flex justify-center">
              <button type="submit" class="w-[100px] h-8 bg-blue-900 text-white rounded hover:bg-blue-800 transition duration-300">
                {{ isEditing ? "Modifier" : "Ajouter" }}
              </button>
              <button v-if="isEditing" type="button" @click="annulerModification" class="ml-4 w-[100px] h-8 bg-gray-500 text-white rounded hover:bg-gray-600 transition duration-300">
                Annuler
              </button>
            </div>
          </form>
        </div>

        <div>
          <h2 class="text-1xl font-bold mb-4">Liste des événements</h2>

          <table class="min-w-full bg-white rounded shadow font-serif">
            <thead>
              <tr class="bg-blue-900 text-white text-left">
                <th class="py-2 px-4">Titre</th>
                <th class="py-2 px-4">Début</th>
                <th class="py-2 px-4">Fin</th>
                <th class="py-2 px-4">Type</th>
                <th class="py-2 px-4">Niveau</th>
                <th class="py-2 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="event in eventList" :key="event.id" class="border-b">
                <td class="py-2 px-4">{{ event.titre }}</td>
                <td class="py-2 px-4">{{ formatDate(event.start) }}</td>
                <td class="py-2 px-4">{{ event.end ? formatDate(event.end) : '-' }}</td>
                <td class="py-2 px-4">{{ event.type }}</td>
                <td class="py-2 px-4">{{ event.niveau }}</td>
                <td class="py-4 px-4 flex space-x-4">
                  <button @click="editerEvent(event)">
                    <img src="/image/im40.png" alt="Modifier" class="w-5 h-5 hover:scale-110 transition" />
                  </button>
                  <button @click="supprimerEvent(event.id)">
                    <img src="/image/im41.png" alt="Supprimer" class="w-5 h-5 hover:scale-110 transition" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'EventView',
  data() {
    return {
      form: {
        id: null,
        titre: '',
        start: '',
        end: '',
        niveau: '',
        type: ''
      },
      eventList: [],
      isEditing: false,
    }
  },
  mounted() {
    this.getEvents()
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    getEvents() {
  axios.get('https://mida-back.onrender.com/api/events')
    .then(response => {
      this.eventList = response.data.data
      console.log('Événements récupérés:', this.eventList) 
    })
    .catch(err => {
      console.error('Erreur récupération événements', err)
      console.error('Réponse complète:', err.response) 
    })
},

    ajouterEvent() {
      if (!this.form.titre || !this.form.start || !this.form.niveau || !this.form.type) {
        alert("Veuillez remplir tous les champs obligatoires.")
        return
      }

      axios.post('https://mida-back.onrender.com/api/events', this.form)
        .then(() => {
          alert('Événement ajouté avec succès !')
          this.reinitialiserForm()
          this.getEvents()
        })
        .catch(error => {
          alert('Erreur lors de l\'ajout de l\'événement')
          console.error(error.response.data)
        })
    },

    editerEvent(event) {
      this.isEditing = true
      this.form = { 
        ...event,
        start: event.start.replace(' ', 'T').slice(0, 16),
        end: event.end ? event.end.replace(' ', 'T').slice(0, 16) : ''
      }
    },

    modifierEvent() {
      if (!this.form.titre || !this.form.start || !this.form.niveau || !this.form.type) {
        alert("Veuillez remplir tous les champs obligatoires.")
        return
      }

      if (!confirm("Voulez-vous vraiment modifier cet événement ?")) return

      axios.put(`https://mida-back.onrender.com/api/events/${this.form.id}`, this.form)
        .then(() => {
          alert('Événement modifié avec succès !')
          this.reinitialiserForm()
          this.getEvents()
          this.isEditing = false
        })
        .catch(error => {
          alert('Erreur lors de la modification de l\'événement')
          console.error(error.response.data)
        })
    },

    supprimerEvent(id) {
      if (!confirm("Voulez-vous vraiment supprimer cet événement ?")) return

      axios.delete(`https://mida-back.onrender.com/api/events/${id}`)
        .then(() => {
          alert('Événement supprimé avec succès !')
          this.eventList = this.eventList.filter(e => e.id !== id)
        })
        .catch(error => {
          alert('Erreur lors de la suppression de l\'événement')
          console.error(error.response.data)
        })
    },

    annulerModification() {
      this.isEditing = false
      this.reinitialiserForm()
    },

    reinitialiserForm() {
      this.form = {
        id: null,
        titre: '',
        start: '',
        end: '',
        niveau: '',
        type: ''
      }
    }
  }
}
</script>

<style scoped>
.nav-container {
  background-color: #163767;
}

.nav-container {
  position: sticky;
  top: 0;
  height: 100vh;
}

input, select {
  display: block;
  margin: 5px 0;
  padding: 8px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
</style>